import template from './settlement-name.jade';

export default angular
    .module('cian.addForm.settlementName', [])
    .directive('cianAfAboutObjectSettlementName', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller: [function () { }],
        controllerAs: 'settlementName',
        template,
    }))
    .name;
